module.exports = __webpack_public_path__ + "static/media/mobile.45102f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile.png
// module id = 2427
// module chunks = 7